import { render } from "./MasterSwitchModal.vue?vue&type=template&id=7aa507b2&scoped=true"
import script from "./MasterSwitchModal.vue?vue&type=script&lang=js"
export * from "./MasterSwitchModal.vue?vue&type=script&lang=js"

import "./MasterSwitchModal.vue?vue&type=style&index=0&id=7aa507b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa507b2"]])

export default __exports__